import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("template", {
    slot: "header"
  }, [_c("div", {
    staticClass: "wlc-space-between"
  }, [_c("div", [_vm._v(" " + _vm._s(_vm.userInfo.name) + " - " + _vm._s(_vm.userInfo.phone) + " - " + _vm._s(_vm.userInfo.createTime) + " "), _vm.userInfo.remark ? _c("el-tag", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      type: "success",
      size: "small"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.remark))]) : _vm._e()], 1), _vm.backVisible ? _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_vm._v("返回")]) : _vm._e()], 1)]), _c("div", {
    staticClass: "wlc-chat-input"
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 3
      },
      placeholder: "请输入内容",
      resize: "none",
      autofocus: true
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }), _c("div", {
    staticClass: "btn-group"
  }, [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.sendImageMessagegDialog
    }
  }, [_vm._v("发送图片")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.sendMessage
    }
  }, [_vm._v("发送消息")])], 1)], 1), _c("div", {
    staticClass: "messageRecord"
  }, [_c("div", {
    staticClass: "message-content-wrap"
  }, [_c("div", {
    staticClass: "messageContent"
  }, _vm._l(_vm.tableData, function (item) {
    var _item$user, _item$user2, _item$parsedResult;
    return _c("div", {
      key: item.id,
      staticClass: "message-li"
    }, [_c("wlc-image", {
      staticClass: "message-img",
      attrs: {
        src: (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.avatar,
        compression: true,
        width: "50"
      }
    }), _c("div", {
      staticClass: "message-text"
    }, [_c("p", [_c("span", {
      staticClass: "message-user"
    }, [_vm._v(_vm._s((_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.name))]), _c("span", {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(item.create))])]), item.objectName == "RC:TxtMsg" ? _c("div", {
      staticClass: "message-c",
      domProps: {
        innerHTML: _vm._s(_vm.textMessageFormat(item.msg))
      }
    }) : _vm._e(), item.objectName == "fraudTip" ? _c("div", {
      staticClass: "message-c",
      domProps: {
        innerHTML: _vm._s(item.msg)
      }
    }) : _vm._e(), item.objectName == "system" ? _c("div", {
      staticClass: "message-c"
    }, [item.msg.MsgType == "TIMTextElem" ? _c("span", [_vm._v(_vm._s(item.msg.MsgContent.Text))]) : item.msg.MsgType == "TIMImageElem" ? _c("wlc-image", {
      attrs: {
        src: item.msg.MsgContent.ImageInfoArray[0].URL,
        width: "200"
      }
    }) : item.msg.MsgType == "TIMCustomElem" ? _c("span", [_vm._v(_vm._s(item.msg.MsgContent.Desc))]) : _c("span", [_vm._v(_vm._s(item.msg))])], 1) : _vm._e(), item.objectName == "RC:ImgMsg" ? _c("div", [_c("wlc-image", {
      attrs: {
        src: item.msg.indexOf("rongcloud") > -1 || item.msg.indexOf("wellcee.com") > -1 || item.msg.indexOf("myqcloud.com") > -1 ? item.msg : "data:image/jpeg;base64," + item.msg,
        width: "200"
      }
    })], 1) : _vm._e(), item.objectName == "comment" ? _c("div", [_vm._v(" " + _vm._s(item.msg.fromUser && item.msg.fromUser.name) + " "), _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v(_vm._s(item.msg.content || item.msg))])], 1) : _vm._e(), item.objectName == "collect" ? _c("div", [_vm._v(" " + _vm._s(item.msg.fromUser && item.msg.fromUser.name) + " "), _c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("收藏了房源")])], 1) : _vm._e(), item.objectName == "RC:LBSMsg" ? _c("div", [_c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("位置消息")])], 1) : _vm._e(), item.objectName == "RC:SightMsg" ? _c("div", [_c("video", {
      staticStyle: {
        width: "160px"
      },
      attrs: {
        src: item.msg,
        controls: ""
      }
    })]) : _vm._e(), item.objectName == "RC:VcMsg" ? _c("div", [_c("el-tag", {
      attrs: {
        type: "success"
      }
    }, [_vm._v("语音消息")])], 1) : _vm._e(), item.objectName == "RC:HQVCMsg" ? _c("div", {
      staticClass: "audio-box"
    }, [_c("audio", {
      attrs: {
        controls: "",
        src: item.msg.remoteUrl
      }
    }), _c("div", [item !== null && item !== void 0 && (_item$parsedResult = item.parsedResult) !== null && _item$parsedResult !== void 0 && _item$parsedResult.result ? _c("div", {
      staticClass: "parsed-result"
    }, [_vm._v(" " + _vm._s(item.parsedResult.result) + " ")]) : _vm._e()])]) : _vm._e()])], 1);
  }), 0)])]), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "发送图片",
      visible: _vm.sendImageMessagegDialogVisible,
      width: "500px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.sendImageMessagegDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "图片"
    }
  }, [_c("wlc-upload-image", {
    attrs: {
      url: _vm.imageUrl
    },
    on: {
      "update:url": function updateUrl($event) {
        _vm.imageUrl = $event;
      }
    }
  })], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.sendImageMessagegDialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.sendImageMessage
    }
  }, [_vm._v("发 送")])], 1)], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };